export default __webpack_public_path__ + "static/media/giftcard.ec5987a1.svg";